import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import DealService from '../../api/services/DealService';

const AddDeal = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState()
  const [fileMobile, setMobileFile] = useState()
  const [fileTablet, setTabletFile] = useState()
  const [error, setError] = useState("")
  const [smallicon, setSmallIcon] = useState()
  const [is_home_page, setIs_home_page] = useState();
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onIconChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var smallicon = fileReader.result
      setSmallIcon(smallicon)
    }
  }
  const onFileMobileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var mobileicon = fileReader.result
      setMobileFile(mobileicon)
    }
  }
  const onFileTabletChange = (e) => {

    const fileReader = new FileReader()

    fileReader.onload = () => {
      var tableticon = fileReader.result
      setTabletFile(tableticon)
    }
    fileReader.readAsDataURL(e.target.files[0]);
  }

  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        title: event.target.title.value,
        "de_title": event.target.de_title.value,
        sub_title: event.target.sub_title.value,
        "de_sub_title": event.target.de_sub_title.value,
        description: event.target.description.value,
        "de_description": event.target.de_description.value,
        button_text: event.target.button_text.value,
        "de_button_text": event.target.de_button_text.value,
        button_link: event.target.button_link.value,
        is_home_page: is_home_page ? is_home_page : 1,
        logo: file ? file.split(',')[1] : "",
        feature_image: smallicon ? smallicon.split(',')[1] : "",
        tablet_image: fileTablet ? fileTablet.split(',')[1] : "",
        mobile_image: fileMobile ? fileMobile.split(',')[1] : ""
      }
      let responseData = await DealService.store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/deal");
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };
  return (
    <>
      <MainPagetitle mainTitle="Add Deal" pageTitle={'Add Deal'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Deal</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='sub_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_sub_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Description<span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Description<span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Button Text<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='button_text' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Button Text<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_button_text' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Button Link<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='button_link' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Is Homepage<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="camper_type_id" onChange={(e) => setIs_home_page(e.target.value)}>

                        <option value="1">True</option>
                        <option value="0">False</option>

                      </select>
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Logo <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={file} alt='' width={file ? 100 : 0} height={file ? 100 : 0} />
                      <input type="file" className="form-control" name='icon' id="val-number" onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Desktop Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={smallicon} alt='' width={smallicon ? 100 : 0} height={smallicon ? 100 : 0} />
                      <input type="file" className="form-control" name='smallicon' id="val-number" onChange={onIconChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Mobile Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={fileMobile} alt='' width={fileMobile ? 100 : 0} height={fileMobile ? 100 : 0} />
                      <input type="file" className="form-control" name='mobile_image' id="val-number" onChange={onFileMobileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Tablet Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={fileTablet} alt='' width={fileTablet ? 100 : 0} height={fileTablet ? 100 : 0} />
                      <input type="file" className="form-control" name='tablet_image' id="val-number" onChange={onFileTabletChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                  </div>
                  {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                    {/* <Link to={"#"} onClick={()=>setAddEmploye(false)} className="btn btn-danger light ms-1">Cancel</Link> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default AddDeal;